<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="SearchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container ref="TableContainer" @Refresh="Refresh" @openReport="openReport" :scrId="scrId" />
				</sf-card>
			</div>
			<popup-detail ref="popupReport" @Refresh="Refresh" :scrId="scrId"></popup-detail>
		</div>
	</div>
</template>

<script>
import SearchContainer from './Search/Search';
import TableContainer from './Table/Table';
import PopupDetail from './Popup/Popup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {},
	components: { SearchContainer, TableContainer, PopupDetail },
	methods: {
		Refresh() {
			this.$refs.SearchContainer.searchList();
		},
		openReport(row) {
			this.$refs.popupReport.open(row);
		}
	}
};
</script>

<style></style>
